import { render, staticRenderFns } from "./PictionaryComponent.vue?vue&type=template&id=6b42107c&scoped=true&"
import script from "./PictionaryComponent.vue?vue&type=script&lang=js&"
export * from "./PictionaryComponent.vue?vue&type=script&lang=js&"
import style0 from "./PictionaryComponent.vue?vue&type=style&index=0&id=6b42107c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b42107c",
  null
  
)

export default component.exports